import React from 'react'
import { Container, Topbar, Button, ProgressSteps, Label, Title } from '@bsf/force-ui'
import { Link } from "../../router/link";
import { routes } from "../../admin/settings/routes";
import { X, Check } from 'lucide-react';
import { __ } from "@wordpress/i18n";
import Welcome from './Welcome';
import OB from './index'

const Onboarding = () => {

    return (
        <>
        <OB />
        </>
    )
}

export default Onboarding
